import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { RoomStatusDropdownComponent } from '@rocksoft/shared';
import { selectHasCurrentMobileReservation } from '../../../stores/mobilereservation/mobilereservation.selector';
import { RoomStatusRoomCheckedIn, RoomStatusRoomCheckedOut } from '../../../stores/rooms/rooms.actions';
import { selectCurrentRoom } from '../../../stores/rooms/rooms.selector';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-room-status',
  templateUrl: './room-status.component.html',
  imports: [RoomStatusDropdownComponent],
})
export class RoomStatusComponent {
  private readonly store = inject(Store);

  public readonly room = this.store.selectSignal(selectCurrentRoom);
  public readonly roomIsCheckedIn = this.store.selectSignal(selectHasCurrentMobileReservation);

  updateRoomCheckInState(isCheckedIn: boolean) {
    const room = this.room();

    if (!room) return;

    const action = isCheckedIn ? new RoomStatusRoomCheckedIn(room) : new RoomStatusRoomCheckedOut(room);
    this.store.dispatch(action);
  }
}
